export const keywords =
  'itr filing for business income, itr filing for small business, itr filing for sole proprietorship, itr filing for partnership firm, itr filing for limited liability partnership, itr filing for company, income tax return filing for business income, cleartax itr filing for business income';

export const canonical = 'https://cleartax.in/itr-filing-for-business-income';

export const description =
  'ITR Filing for Business & Professional Income: File Income Tax Return for freelancers, professionals, FnO traders, sole proprietors, partners & other businesses in India.';

export const pageTitle =
  'ITR Filing for Business & Professional Income | ClearTax';
